/**
 * Immediately refresh the browser to the given href
 * @param {string} href
 */
export const refresh = (href) => {
    console.info(`${import.meta.env.VITE_APP_NAME} has been updated, refreshing...`);
    window.location.href = href;
};

// Detect a chunk load error from an error message
const isChunkLoadError = (reason) => {
    const message = typeof reason === 'string'
        ? reason
        : reason?.message;

    if ( !message ) {
        return false;
    }

    return /__esModule|dynamically imported module|Importing a module script failed/i.test(message);
};

// Guard against a refresh loop if a chunk stays unreachable after refreshing
const refreshedRecently = () => {
    const refresh_guard_key = 'chunk_error_refresh';
    const last_refresh = Number(sessionStorage.getItem(refresh_guard_key)) || 0;

    if ( Date.now() - last_refresh < 10000 ) {
        return true;
    }

    // iOS Safari private mode throws on storage writes
    try {
        sessionStorage.setItem(refresh_guard_key, String(Date.now()));
    } catch ( error ) {
        //
    }

    return false;
};

/**
 * Refresh the page when certain errors are detected
 * @param {Vue} app
 */
export const refreshOnError = (app) => {
    // Refresh the page to the last route clicked by the user
    // PROD: immediately
    // DEV: after 10 seconds so the error stays readable
    const reload = (event) => {
        try {
            event?.preventDefault();
        } catch ( error ) {
            //
        }

        if ( typeof event !== 'undefined' ) {
            console.error(event);
        }

        const route_to = app.$store.state.route_to || window.location.href;

        if ( import.meta.env.DEV ) {
            setTimeout(() => {
                refresh(route_to);
            }, 10000);
        } else {
            refresh(route_to);
        }
    };

    // router errors
    app.$router.onError(reload);

    // Vite preload errors
    window.addEventListener('vite:preloadError', reload);

    // stale lazy-loaded chunk errors
    window.addEventListener('unhandledrejection', (event) => {
        if ( isChunkLoadError(event?.reason) && !refreshedRecently() ) {
            reload(event);
        }
    });
}
